/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Ask_SuggestionsInputs */

const en_us2_plan_build_ask_suggestions = /** @type {(inputs: Plan_Build_Ask_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask the trainer for suggestions`)
};

const pt_br2_plan_build_ask_suggestions = /** @type {(inputs: Plan_Build_Ask_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir sugestões ao personal`)
};

const es_419_plan_build_ask_suggestions = /** @type {(inputs: Plan_Build_Ask_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir sugerencias al entrenador`)
};

const pt_pt2_plan_build_ask_suggestions = /** @type {(inputs: Plan_Build_Ask_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir sugestões ao treinador`)
};

const fr_fr2_plan_build_ask_suggestions = /** @type {(inputs: Plan_Build_Ask_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander des suggestions au coach`)
};

const de_de2_plan_build_ask_suggestions = /** @type {(inputs: Plan_Build_Ask_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach nach Vorschlägen fragen`)
};

const it_it2_plan_build_ask_suggestions = /** @type {(inputs: Plan_Build_Ask_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi suggerimenti al coach`)
};

/**
* | output |
* | --- |
* | "Ask the trainer for suggestions" |
*
* @param {Plan_Build_Ask_SuggestionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_ask_suggestions = /** @type {((inputs?: Plan_Build_Ask_SuggestionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Ask_SuggestionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_ask_suggestions(inputs)
	if (locale === "es-419") return es_419_plan_build_ask_suggestions(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_ask_suggestions(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_ask_suggestions(inputs)
	if (locale === "de-DE") return de_de2_plan_build_ask_suggestions(inputs)
	if (locale === "it-IT") return it_it2_plan_build_ask_suggestions(inputs)
	return en_us2_plan_build_ask_suggestions(inputs)
});
export { plan_build_ask_suggestions as "plan-build.ask_suggestions" }